import { useContext } from "react";
import { useQuery } from "react-query";

import { ShopContext } from "../../../utils/Shop";
import { Screen } from "../../../utils/types";
import { get_screen_by_id, get_screens_by_shop_id } from "../../Client";

export const useScreensQuery = () => {
    const { shopId } = useContext(ShopContext);
    const { data, isLoading } = useQuery<Screen[]>(["screens", shopId], () => get_screens_by_shop_id(shopId), {
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });

    return { screenOptions: data ?? [], isLoading };
};

export const useGetScreenByIdQuery = (screenId: string, enabled?: boolean) => {
    const { data, isLoading } = useQuery<Screen>(["screen", screenId], () => get_screen_by_id(screenId), {
        enabled: enabled,
        refetchOnWindowFocus: false,
        keepPreviousData: true,
    });
    return { screen: data, isLoading };
};
